import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=ac0ccb4c&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "../Style/edit.scss?vue&type=style&index=0&id=ac0ccb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0ccb4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac0ccb4c')) {
      api.createRecord('ac0ccb4c', component.options)
    } else {
      api.reload('ac0ccb4c', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=ac0ccb4c&scoped=true&", function () {
      api.rerender('ac0ccb4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SprintPlanning/Components/Edit.vue"
export default component.exports